export const LOGIN_ENDPOINT = '/api/web/login-platform';
export const LOGIN_CHECK_ENDPOINT = '/api/web/login_check'
export const LOGOUT_ENDPOINT = '/api/web/logout';
export const REGISTER_S1_ENDPOINT = '/api/web/register/validation/step1';
export const REGISTER_S2_ENDPOINT = '/api/web/register/validation/step2';
export const REGISTER_S3_ENDPOINT = '/api/web/register/validation/step3';
export const REGISTER_S4_ENDPOINT = '/api/web/register/step4';
export const IMPERSONATE_ENDPOINT = '/api/web/impersonate'

// Product

export const GET_PRODUCTS_ENDPOINT = '/api/web/my/products';
export const GET_PRODUCT_ENDPOINT = '/api/web/product';
export const ADD_PRODUCT_DATA_ENDPOINT = '/api/web/product';
export const UPDATE_PRODUCT_ENDPOINT = '/api/web/product';
export const DELETE_PRODUCT_ENDPOINT = '/api/web/product';
export const PUBLISH_PRODUCT_ENDPOINT = '/api/web/product/publish';
export const UNPUBLISH_PRODUCT_ENDPOINT = '/api/web/product/unpublish';

export const TOGGLE_ALLOW_DOWNLOAD_ENDPOINT = '/api/web/product/allow-download'
export const TOGGLE_ALLOW_SHARE_ENDPOINT = '/api/web/product/allow-share'
export const TOGGLE_ALLOW_FAVOURITE_ENDPOINT = '/api/web/product/allow-favourite'
export const TOGGLE_FEATURED_ENDPOINT = '/api/web/product/toggle-featured'
export const TOGGLE_RE3D_ENDPOINT = '/api/web/product/toggle-re3d'

// Categories
export const GET_CATEGORIES_ENDPOINT = '/api/web/categories';

// Messages
export const GET_MESSAGES_ENDPOINT = '/api/web/my-messages';
export const GET_REPORTS_ENDPOINT = '/api/web/my-complaints';
export const GET_SUPERADMIN_REPORTS_ENDPOINT = '/api/web/problem/admin';
export const ADD_MESSAGE_ENDPOINT = '/api/web/message'
export const READ_MESSAGES_ENDPOINT = '/api/web/messages/read'
export const DELETE_MESSAGES_ENDPOINT = '/api/web/message/delete'

// Notifications
export const ADD_NOTIFICATION_ENDPOINT = '/api/web/notifications'
export const GET_NOTIFICATIONS_ENDPOINT = '/api/web/notifications'
export const UPDATE_NOTIFICATION_ENDPOINT = '/api/web/notification'
export const TOGGLE_NOTIFICATION_ENDPOINT = '/api/web/notification/toggle'
export const DELETE_NOTIFICATION_ENDPOINT = '/api/web/notification'
export const GET_NOTIFICATION_CATEOGIRES_ENDPOINT = '/api/web/notifications-category'

export const GET_USER_NOTIFICATIONS_ENDPOINT = '/api/web/message/notification'

// user
export const UPDATE_USER_ENDPOINT = '/api/web/profile'
export const UPDATE_USER_PHOTO_ENDPOINT = '/api/web/profile/photo'
export const FINISH_TUTORIAL_ENDPOINT = '/api/web/profile/watched-tutorial'
export const DELETE_MY_PROFILE_ENDPOINT = '/api/web/merchant'
export const RESET_PASSWORD_ENDPOINT = '/api/web/reset/password'
export const REQUEST_RESET_PASSWORD_ENDPOINT = '/api/web/forgot/password'
export const RESET_PASSWORD_TOKEN_ENDPOINT = '/api/web/forgot/password'

// Subscriptions
export const GET_SUBSCRIPTIONS_ENDPOINT = '/api/web/subscriptions'
export const ADD_SUBSCRIPTIONS_ENDPOINT = '/api/web/add-subscriptions'
export const ADD_SUBSCRIPTION_ENDPOINT = '/api/web/add-subscription'
export const UPDATE_SUBSCRIPTION_PAYMENT_BY_MERCHANT_ENDPOINT = '/api/web/payed/subscription'
export const GET_SUBSCRIPTION_BY_DOMAIN_ENDPOINT = '/api/web/subscription/domain'
export const UPGRADE_SUBSCRIPTION_ENDPOINT = '/api/web/upgrade-subscription'
export const GET_MY_ACCOUNT_SUBSCRIPTIONS_ENDPOINT = '/api/web/subscription/my-account'

// Tags
export const GET_TAGS_ENDPOINT = '/api/web/tags'

// New Statistics
export const GET_STATISTICS_FOR_USER = '/api/web/statistics'
export const GET_STATISTICS_BY_PRODUCT_ENDPOINT = '/api/web/statistics/product'
export const GET_STATISTICS_BY_STORY_ENDPOINT = '/api/web/statistics/story'

// Old Statistics
export const GET_STATISTICS_BY_DOMAIN_SUPER_ADMIN_ENDPOINT = '/api/web/statistics-super-admin/domain'
export const GET_STATISTICS_BY_CATEGORY_ENDPOINT = '/api/web/statistics/merchant/category'
export const GET_TIMELINE_BY_PRODUCT_ENDPOINT = '/api/web/statistics/timeline'
export const GET_LOG_STATISTICS_ENDPOINT = '/api/web/statistics/export/main'
export const GET_LOG_STATISTICS_SUPER_ADMIN_ENDPOINT = '/api/web/statistics-super-admin/export/main'
export const GET_LOG_TYPES_ENDPOINT = '/api/web/statistics/actionTypes/consumer'
export const GET_STATISTICS_BY_DOMAIN_BY_DAYS_ENDPOINT = (domainId, from, until) => `/api/web/statistics/chart/${domainId}/${from}/${until}`

// Merchants
export const GET_MERCHANTS_ENDPOINT = '/api/web/merchants'
export const GET_MERCHANT_PRODUCTS_ENDPOINT = '/api/web/superadmin/all-merchants-products'
export const ADD_MERCHANT_ENDPOINT = '/api/web/add/merchant'
export const DELETE_MERCHANT_ENDPOINT = '/api/web/merchant'
export const UNBLOCK_MERCHANT_ENDPOINT = '/api/web/unblock-merchant'

// Category
export const UPDATE_CATEGORY_ENDPOINT = (categoryId) => `/api/web/category/${categoryId}`
export const DELETE_CATEGORY_ENDPOINT = (categoryId) => `/api/web/category/${categoryId}`
export const DELETE_NOTIFICATIONS_CATEGORY_ENDPOINT = (categoryId) => `/api/web/notifications-category/${categoryId}`
export const ADD_DOMAIN_CATEGORY_ENDPOINT = '/api/web/category'
export const ADD_NOTIFICATION_CATEGORY_ENDPOINT = '/api/web/notifications-category'
export const GET_DOMAINS_AND_CATEGORIES_ENDPOINT = '/api/web/domains-and-categories'

// Stories
export const GET_STORIES_ENDPOINT = '/api/web/stories'
export const GET_STORIES_REQUESTS_ENDPOINT = '/api/web/stories-requests'
export const CREATE_STORY_ENDPOINT = '/api/web/stories'
export const UPDATE_STORY_ENDPOINT = (storyId) => `/api/web/stories/${storyId}`
export const GET_STORY_ENDPOINT = (storyId) => `/api/web/stories/${storyId}`
export const DELETE_STORY_ENDPOINT = (storyId) => `/api/web/stories/${storyId}`



// WEBPACK FOOTER //
// ./src/lib/endpoints.js